import React from 'react';
import { ProductCode, ProductCodeKey } from '@dayetopia/types';
import { useLocation } from '@reach/router';
import { styled } from 'styled-components';
import Colors from '@components/shared/Colors';
import { VariantItem } from '@contracts';
import { pageIsAdsPage } from '@utils/helpers';
import ProductItemIcon from './ProductItemIcon';

interface Props {
  variants?: VariantItem[];
}

const ProductWhatsInside: React.FC<Props> = ({ variants }) => {
  const location = useLocation();

  const getProductName = (variant: string) => {
    if (variant === ProductCodeKey.VMSEssential) {
      return 'Diagnostic Tampon';
    }

    let variantName = ProductCode[variant as keyof typeof ProductCode] as string;

    const isAdsPage: boolean = pageIsAdsPage(location.pathname);
    const shouldReplaceCBDWording = (location.pathname.includes('/products/organic-coated-tampons') || isAdsPage) && variantName.includes('CBD');
    if (shouldReplaceCBDWording) {
      variantName = variantName.replace('CBD', 'Coated');
    }

    return variantName;
  };

  return (
    <Container>
      {variants
        ?.filter((item) => item.count > 0)
        .map((item) => (
          <Variant key={item.variant}>
            <ProductItemIcon code={item.variant} /> {`${item.count} ${getProductName(item.variant)}`}
          </Variant>
        ))}
    </Container>
  );
};

export default ProductWhatsInside;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
`;

const Variant = styled.div`
  display: flex;
  padding: 10px 15px;
  align-items: center;
  gap: 5px;
  border-radius: 100px;
  background: ${Colors.ecru50};

  font-family: 'BrownStd';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;

  & > svg {
    width: auto;
    height: 20px;
    margin-right: 4px;
  }
`;
